export { default } from './SkeletonInteractiveMapMobile';
